import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { SectionModel, TableModel } from '@flocasts/experience-service-types'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'

/**
 * @deprecated
 * BFF is deprecating sections, please use the table component instead.
 * @see TableComponent
 */
@Component({
  selector: 'flo-section-table',
  templateUrl: './section-table.component.html',
  styleUrls: ['./section-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SectionTableComponent {
  @Input()
  section: SectionModel<TableModel>

  readonly trackById = trackById
}
